/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('global/EventManager',[
    './Logger'
], function (Logger) {
    'use strict';

    var bindings = {};
    var pending = {}; // pending data for first event listener

    /**
     * 
     * @param event - Event type
     * @param {Object} info - Event argument
     * @param {bool} keep [false] - if 'true' the event data will be kept until first listener binding, then it will be passed as an event argument.
     * @returns {} 
     */
    function notify(event, info, keep) {
        if (keep === null) {
            keep = false;
        }
        if (!bindings.hasOwnProperty.call(bindings, event)) {
            if (keep) {
                pending[event] = info;
            }
            return;
        }
        bindings[event].forEach(function (item) {
            item(info !== undefined ? info : {});
        });
    }

    function bind(event, listener) {
        if (!bindings.hasOwnProperty.call(bindings, event)) {
             bindings[event] = [];
        }
        if (pending.hasOwnProperty.call(pending, event)) {
            listener(pending[event]);
            delete pending[event];
        }
        var index = bindings[event].push(listener) - 1;
        return {
            remove: function () {
                delete bindings[event][index];
            }
        };
    }

    var EventManager = {
        bind: bind,
        notify: notify
    };

    Logger.debug('EventManager.js Loaded:', EventManager);

    return EventManager;
});

